const envExample = {
    name: '跶跶出行',
    logo: '/images/ddcx.jpg',
    AMap: {
        key: 'b83b6d7a360702c363a2c22b8cd28f1b'
    },
    isPosSwitch:false,//false不允许切换商户,true允许商户切换
}
export default envExample;
